import type { ReactNode } from "react";

export function Spinner({ large = false }: { large?: boolean }) {
  return <div className={large ? "spinner spinner-lg" : "spinner"} aria-hidden="true" />;
}

export function Waiting({ children, centered = false }: { children: ReactNode; centered?: boolean }) {
  return (
    <div className={centered ? "waiting waiting-centered" : "waiting"} role="status">
      <Spinner />
      {children}
    </div>
  );
}
